var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mpn-infobox"},[_vm._l((_vm.computedMsgs),function(message,index){return _c('p',{key:index,domProps:{"innerHTML":_vm._s(_vm.toHtml(message))}})}),_vm._v(" "),_c('p',{staticClass:"gap"}),_vm._v(" "),_c('mpn-basic-button',{on:{"click":_vm.onClickConfirm}},[_vm._v("\n    확인\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-096356cb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/InfoBox.vue
// module id = null
// module chunks = 